export default __webpack_public_path__ + "static/media/orion-icon.df4186e9.svg";